import { createApp } from 'vue'
import * as Vue from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "bootstrap-input-spinner"
import "@/css/style.css"
import router from "./router"
import store from '@/store'
import Loading from "@/widgets/Loading.vue"
import Breadcrumb from "@/widgets/Breadcrumb.vue"
import Progress from "@/widgets/Progress.vue"
import mitt from 'mitt'
import config from "@/config/index.js"
import 'vue-universal-modal/dist/index.css'
import VueUniversalModal from 'vue-universal-modal'

const app = createApp(App);
app.use(router);
app.use(store);
app.use(config);
app.use(VueUniversalModal, {
    teleportTarget: '#modal'
});
app.component('Loading', Loading);
app.component('Breadcrumb', Breadcrumb);
app.component('Progress', Progress);
app.config.globalProperties.$emitter = mitt();
app.mount('#app');
